import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import { MdDeleteForever } from "react-icons/md";
import numberbeautify from "../../utils/numberbeautify";
import deleteaction from "../../context/action/buy/deleteaction";
import getitemaction from "../../context/action/item/getitemaction";
import updateaction from "../../context/action/buy/updateaction";
import money_rounding from "../../utils/money_rounding";

const Buyinvoicedetailmodal = (props) => {
  const { initState, recaller, setrecaller, clear, initDispatch } =
    useContext(GlobalContext);

  const [text, settext] = useState();
  return (
    <>
      {props.show ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative my-6 mx-auto w-11/12 md:w-11/12 lg:w-11/12">
              {/*content*/}
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                {/*header*/}
                <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                  <h3 className="text-xl sm:text-2xl md:text-3xl uppercase font-semibold flex-1">
                    گۆڕانکاری
                  </h3>
                  <button
                    className="p-1 ml-auto bg-transparent border-0 text-black opacity-80 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                    onClick={() => props.setshow(false)}
                  >
                    <span className="bg-transparent text-black h-6 w-6 text-2xl block outline-none focus:outline-none">
                      X
                    </span>
                  </button>
                </div>
                {/*body*/}
                <div className="relative max-h-[80vh] overflow-y-auto p-4 sm:p-6 flex-auto">
                  <div className="flex flex-wrap w-full">
                    <div className="w-full px-0 sm:px-3 my-2">
                      <label
                        className={
                          "block uppercase tracking-wide text-white text-xs font-bold mb-2"
                        }
                        htmlFor="item_name"
                      >
                        ناوی ئایتم / کۆد
                      </label>
                      <input
                        className={
                          "appearance-none block w-full bg-white text-black border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                        }
                        id="item_name"
                        type="text"
                        placeholder=""
                        onClick={(val)=>{val.target.select()}}
                        value={text}
                        onChange={(val) => settext(val.target.value)}
                        onKeyDown={(key) => {
                          if (key.key == "Enter") {
                            getitemaction(text)(recaller)(setrecaller)(
                              props.items
                            )(props.setitems)(settext)(clear);
                          }
                        }}
                      />
                    </div>
                    <div className="w-full overflow-x-auto">
                    <table className="min-w-full leading-normal text-[10px] sm:text-xs md:text-sm">
                      <thead>
                        <tr>
                          <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-[10px] sm:text-xs font-semibold text-gray-700 uppercase tracking-wider">
                            ناوی کاڵا
                          </th>
                          <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-[10px] sm:text-xs font-semibold text-gray-700 uppercase tracking-wider">
                            کۆد
                          </th>
                          <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-[10px] sm:text-xs font-semibold text-gray-700 uppercase tracking-wider">
                            نرخی کڕین
                          </th>
                          <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-[10px] sm:text-xs font-semibold text-gray-700 uppercase tracking-wider">
                            بڕ - کۆ
                          </th>
                          <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-[10px] sm:text-xs font-semibold text-gray-700 uppercase tracking-wider">
                            بڕی (CBI) م۳
                          </th>
                          <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-[10px] sm:text-xs font-semibold text-gray-700 uppercase tracking-wider">
                            نرخ - تاک
                          </th>
                          <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-[10px] sm:text-xs font-semibold text-gray-700 uppercase tracking-wider">
                            نرخ - کۆ
                          </th>
                          <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-[10px] sm:text-xs font-semibold text-gray-700 uppercase tracking-wider">
                            کۆی نرخ
                          </th>
                          <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-[10px] sm:text-xs font-semibold text-gray-700 uppercase tracking-wider">
                            نرخی فرۆش
                          </th>
                          <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-[10px] sm:text-xs font-semibold text-gray-700 uppercase tracking-wider">
                            ڕەشکردنەوە
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {props.items.map((lis, index) => (
                          <tr key={index}>
                            <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                              <p className="text-gray-900 whitespace-no-wrap">
                                {lis.item_name}
                              </p>
                            </td>
                            <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                              <p className="text-gray-900 whitespace-no-wrap">
                                {lis.item_barcode}
                              </p>
                            </td>
                            <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                              <input
                                className={
                                  "w-[120px] lg:w-full appearance-none block bg-white text-black border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-12"
                                }
                                id="grid-last-name"
                                type="number"
                                onClick={(val)=>{val.target.select()}}
                                value={lis.company_invoice_item_price}
                                onChange={(val) => {
                                  props.setitems(
                                    props.items.map((lis, indexx) =>
                                      index == indexx
                                        ? {
                                            item_id: lis.item_id,
                                            item_name: lis.item_name,
                                            item_barcode: lis.item_barcode,
                                            item_price: lis.item_price,
                                            item_base_price: val.target.value,
                                            company_invoice_item_qty:
                                              lis.company_invoice_item_qty,
                                            company_invoice_item_price:
                                              val.target.value,
                                            company_invoice_item_cbi_m3:
                                              lis.company_invoice_item_cbi_m3,
                                            company_invoice_item_cbi_total_price:
                                              lis.company_invoice_item_cbi_total_price,
                                            item_unit_one_of_many:
                                              lis.item_unit_one_of_many
                                          }
                                        : lis
                                    )
                                  );
                                }}
                              />
                            </td>
                            <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                              <input
                                className={
                                  "w-[120px] lg:w-full appearance-none block bg-white text-black border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-12"
                                }
                                id="grid-last-name"
                                type="number"
                                onClick={(val)=>{val.target.select()}}
                                value={lis.company_invoice_item_qty}
                                onChange={(val) => {
                                  props.setitems(
                                    props.items.map((lis, indexx) =>
                                      index == indexx
                                        ? {
                                            item_id: lis.item_id,
                                            item_name: lis.item_name,
                                            item_barcode: lis.item_barcode,
                                            item_price: lis.item_price,
                                            item_base_price: lis.item_base_price,
                                            company_invoice_item_qty:
                                              val.target.value,
                                            company_invoice_item_price:
                                              lis.company_invoice_item_price,
                                            company_invoice_item_cbi_m3:
                                              lis.company_invoice_item_cbi_m3,
                                            company_invoice_item_cbi_total_price:
                                              lis.company_invoice_item_cbi_total_price,
                                            item_unit_one_of_many:
                                              lis.item_unit_one_of_many
                                          }
                                        : lis
                                    )
                                  );
                                }}
                              />
                            </td>
                            <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                              <input
                                className={
                                  "w-[120px] lg:w-full appearance-none block bg-white text-black border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-12"
                                }
                                id="grid-last-name"
                                type="number"
                                onClick={(val)=>{val.target.select()}}
                                value={lis.company_invoice_item_cbi_m3}
                                onChange={(val) => {
                                  props.setitems(
                                    props.items.map((lis, indexx) =>
                                      index == indexx
                                        ? {
                                            item_id: lis.item_id,
                                            item_name: lis.item_name,
                                            item_barcode: lis.item_barcode,
                                            item_price: lis.item_price,
                                            item_base_price: lis.item_base_price,
                                            company_invoice_item_qty:
                                              lis.company_invoice_item_qty,
                                            company_invoice_item_price:
                                              lis.company_invoice_item_price,
                                            company_invoice_item_cbi_m3:
                                              val.target.value,
                                            company_invoice_item_cbi_total_price:
                                              money_rounding(Number(val.target.value)*Number(props.company_invoice_cbi_price)),
                                            item_unit_one_of_many:
                                              lis.item_unit_one_of_many
                                          }
                                        : lis
                                    )
                                  );
                                }}
                              />
                            </td>
                            <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                              <p className="text-gray-900 whitespace-no-wrap">
                                {numberbeautify(money_rounding((((Number(lis?.company_invoice_item_price)/Number(props.company_invoice_rmb_price)))+(Number(lis.company_invoice_item_cbi_m3)*Number(props.company_invoice_cbi_price)))/Number(lis.item_unit_one_of_many)))}
                              </p>
                            </td>
                            <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                              <p className="text-gray-900 whitespace-no-wrap">
                                {numberbeautify(money_rounding(((Number(lis?.company_invoice_item_price)/Number(props.company_invoice_rmb_price)))+(Number(lis.company_invoice_item_cbi_m3)*Number(props.company_invoice_cbi_price))))}
                              </p>
                            </td>
                            <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                              <p className="text-gray-900 whitespace-no-wrap">
                                {numberbeautify(money_rounding((Number(lis?.company_invoice_item_price)/Number(props.company_invoice_rmb_price)+Number(lis.company_invoice_item_cbi_m3)*Number(props.company_invoice_cbi_price))*Number(lis?.company_invoice_item_qty)))}
                              </p>
                            </td>
                            <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                              <input
                                className={
                                  "w-[120px] lg:w-full appearance-none block bg-white text-black border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-12"
                                }
                                id="grid-last-name"
                                type="number"
                                onClick={(val)=>{val.target.select()}}
                                value={lis.item_price}
                                onChange={(val) => {
                                  props.setitems(
                                    props.items.map((lis, indexx) =>
                                      index == indexx
                                        ? {
                                            item_id: lis.item_id,
                                            item_name: lis.item_name,
                                            item_barcode: lis.item_barcode,
                                            item_price: val.target.value,
                                            item_base_price: lis.item_base_price,
                                            company_invoice_item_qty:
                                              lis.company_invoice_item_qty,
                                            company_invoice_item_price:
                                              lis.company_invoice_item_price,
                                            company_invoice_item_cbi_m3:
                                              lis.company_invoice_item_cbi_m3,
                                            company_invoice_item_cbi_total_price:
                                              lis.company_invoice_item_cbi_total_price,
                                            item_unit_one_of_many:
                                              lis.item_unit_one_of_many
                                          }
                                        : lis
                                    )
                                  );
                                }}
                              />
                            </td>
                            <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                              <p className="text-gray-900 whitespace-no-wrap">
                                <MdDeleteForever
                                  size={28}
                                  color="#e74c3c"
                                  className="cursor-pointer"
                                  onClick={() => {
                                    props.setitems(
                                      props.items.filter(
                                        (list) => list.item_id != lis.item_id
                                      )
                                    );
                                  }}
                                />
                              </p>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    </div>
                  </div>
                </div>
                {/*footer*/}
                <div className="flex flex-col sm:flex-row items-center justify-end gap-3 p-4 sm:p-6 border-t border-solid border-slate-200 rounded-b">
                    <button
                      className="w-full sm:w-auto bg-red-500 text-white active:bg-red-600 font-bold uppercase text-sm px-4 sm:px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150 order-2 sm:order-1"
                      type="button"
                      onClick={() => {
                        if (
                          window.confirm("ئاگاداری ڕەشکردنەوە . دڵنیای ؟") == true
                        ) {
                          deleteaction(props.company_invoice_id)(recaller)(
                            setrecaller
                          )(initDispatch)(clear);
                        }
                      }}
                    >
                      ڕەشکردنەوە
                    </button>
                    <button
                      className="w-full sm:w-auto bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-4 sm:px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150 order-1 sm:order-2"
                      type="button"
                      onClick={() => {
                        var temp_item=[];
                        for(var i=0;i<props.items.length;i++){
                          var temp_a={
                            item_id: props.items[i].item_id,
                            item_name: props.items[i].item_name,
                            item_barcode: props.items[i].item_barcode,
                            item_price: props.items[i].item_price,
                            item_base_price: props.items[i].item_base_price,
                            // company_invoice_item_qty: props.items[i].company_invoice_item_qty,
                            company_invoice_item_qty: (Number(props.items[i].company_invoice_item_qty)*(props.items[i].item_unit_one_of_many)),
                            company_invoice_item_price: (Number(props.items[i]?.company_invoice_item_price)/Number(props.company_invoice_rmb_price))+(Number(props.items[i]?.company_invoice_item_cbi_m3)*Number(props.company_invoice_cbi_price)),
                            company_invoice_item_cbi_m3: props.items[i].company_invoice_item_cbi_m3,
                            company_invoice_item_cbi_total_price: props.items[i].company_invoice_item_cbi_total_price,
                            item_unit_one_of_many: props.items[i].item_unit_one_of_many
                          }
                          temp_item.push(temp_a);
                        }
                        
                        updateaction(
                          props.company_invoice_id,
                          temp_item
                        )(recaller)(setrecaller)(initDispatch)(clear);
                      }}
                    >
                      گۆڕانکاری
                    </button>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
};

export default Buyinvoicedetailmodal;
